import { useMemo, useState } from "react";
import type { Profile, SocialLink } from "../../data/site";
import { Card } from "../ui/Card";
import { Button } from "../ui/Button";
import "./contact.css";

export function Contact({
  profile,
  notes,
  social
}: {
  profile: Profile;
  notes: string[];
  social: SocialLink[];
}) {
  const [showPhone, setShowPhone] = useState(false);
  const phoneText = showPhone ? profile.phoneFull : profile.phoneMasked;
  const telHref = useMemo(() => (showPhone ? `tel:${profile.phoneFull}` : undefined), [showPhone, profile.phoneFull]);

  return (
    <div className="contact">
      <Card>
        <div className="contact__grid">
          <div>
            <div className="contact__label">邮箱</div>
            <a className="contact__value contact__link" href={`mailto:${profile.email}`}>
              {profile.email}
            </a>
          </div>

          <div>
            <div className="contact__label">手机（公开页默认不完整展示）</div>
            <div className="contact__row">
              {telHref ? (
                <a className="contact__value contact__link" href={telHref}>
                  {phoneText}
                </a>
              ) : (
                <div className="contact__value">{phoneText}</div>
              )}
              <Button variant="ghost" onClick={() => setShowPhone((v) => !v)}>
                {showPhone ? "隐藏" : "显示完整"}
              </Button>
            </div>
          </div>

          <div>
            <div className="contact__label">城市</div>
            <div className="contact__value">{profile.city}</div>
          </div>
        </div>

        <div className="contact__notes">
          <div className="contact__label">说明</div>
          <ul className="contact__list">
            {notes.map((n) => (
              <li key={n}>{n}</li>
            ))}
          </ul>
        </div>
      </Card>

      {social.length ? (
        <div className="contact__social" aria-label="社交链接">
          {social.map((s) => (
            <a className="plink" key={s.href} href={s.href} target={s.href.startsWith("mailto:") ? undefined : "_blank"} rel="noreferrer">
              <span className="plink__label">{s.label}</span>
              <span className="plink__icon" aria-hidden>
                ↗
              </span>
              {s.note ? <span className="contact__socialNote">{s.note}</span> : null}
            </a>
          ))}
        </div>
      ) : null}
    </div>
  );
}

